import { render } from "./GpsRating.vue?vue&type=template&id=36f19fdc&scoped=true"
import script from "./GpsRating.vue?vue&type=script&lang=js"
export * from "./GpsRating.vue?vue&type=script&lang=js"

import "./GpsRating.vue?vue&type=style&index=0&id=36f19fdc&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f19fdc"]])

export default __exports__